import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import Dropdown from './Dropdown';
import logo from '../images/Profile_icon2.png';

function Navbar() {
  const storedJwt = localStorage.getItem('token');
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const onMouseEnter = () => {
    if (window.innerWidth < 960) {
      setDropdown(false);
    } else {
      setDropdown(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth < 960) {
      setDropdown(false);
    } else {
      setDropdown(false);
    }
  };

  const isLoggedIn = () => 
  {
    if (storedJwt === 'null') 
    {
      return false;
    } 
    else 
    {
      return true;
    }
  };

  return (
    <>
      <nav className='navbar'>
        <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
          Pulse Tool<i className="fas fa-hammer"></i>
        </Link>
        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
              Home
            </Link>
          </li>
          <li
            className='nav-item'
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <Link
              to='/LoadTestMain'
              className='nav-links'
              onClick={closeMobileMenu}
            >
            Test Engine <i className='fas fa-caret-down' />
            </Link>
            {dropdown && <Dropdown />}
          </li>
        </ul>

        {isLoggedIn() ? 
          <div>
            <Link to="/MyProfile">
            <img
                  className="rounded-full w-8 h-8"
                  src={logo}
                  alt="user-profile"
                />
            </Link> </div>
         : <div>
                <Link to="/SignIn">
                <img
                      className="rounded-full w-8 h-8"
                      src={logo}
                      alt="user-profile"
                    />
                </Link></div>}
      </nav>
    </>
  );
}

export default Navbar;
